/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewPrivacyCookieCompliance
 */
export interface CRSFSecReviewPrivacyCookieCompliance {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyCookieCompliance
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyCookieCompliance
     */
    tier: string;
}

/**
 * Check if a given object implements the CRSFSecReviewPrivacyCookieCompliance interface.
 */
export function instanceOfCRSFSecReviewPrivacyCookieCompliance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "provider" in value;
    isInstance = isInstance && "tier" in value;

    return isInstance;
}

export function CRSFSecReviewPrivacyCookieComplianceFromJSON(json: any): CRSFSecReviewPrivacyCookieCompliance {
    return CRSFSecReviewPrivacyCookieComplianceFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacyCookieComplianceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacyCookieCompliance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider': json['provider'],
        'tier': json['tier'],
    };
}

export function CRSFSecReviewPrivacyCookieComplianceToJSON(value?: CRSFSecReviewPrivacyCookieCompliance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider': value.provider,
        'tier': value.tier,
    };
}

